"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Modal = require("@insided/shared/uikit/Modal");

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var SelectColumnsModal = function SelectColumnsModal(props) {
  var columns = props.columns,
      showModal = props.showModal,
      onApply = props.onApply,
      onClose = props.onClose,
      onResetToDefault = props.onResetToDefault,
      toggleColumn = props.toggleColumn;

  function formatColumns() {
    return columns.map(function (column, index) {
      return (0, _preact.h)("div", {
        className: "overview-select-columns-modal__column",
        key: index
      }, (0, _preact.h)(_Checkbox.default, {
        label: "",
        onUpdate: function onUpdate(checked) {
          toggleColumn(column.accessor, checked);
        },
        qaClasses: "qa-select-all",
        checked: !column.isHidden,
        disabled: column.isFixed
      }), column.header, " ", column.label && (0, _preact.h)("span", null, column.label));
    });
  }

  return (0, _preact.h)(_Modal.Modal, {
    isOpen: showModal,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Custom table view",
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, formatColumns()), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: "Apply",
    variant: "brand",
    onClick: onApply,
    className: "qa-apply-columns",
    size: "medium"
  }), (0, _preact.h)(_Button.default, {
    title: "Cancel",
    onClick: onClose,
    size: "medium"
  }), (0, _preact.h)(_Button.default, {
    title: "Reset to default",
    onClick: onResetToDefault,
    className: "qa-reset-columns",
    size: "medium"
  })));
};

var _default = SelectColumnsModal;
exports.default = _default;